import { Navigate, NavigateProps } from 'react-router-dom';

import useQueryParams from '../../hooks/useQueryParams';
import Logger from '../../utils/Logger';
import { isMalformedURL } from '../../utils/UrlUtils';

export interface ZenRedirectProps extends NavigateProps {}

interface Query {
  redirectTo?: string;
}

const RedirectRoute: React.FC<ZenRedirectProps> = ({ to, ...rest }) => {
  const { redirectTo } = useQueryParams<Query>();

  let finalTo = to as string;

  if (redirectTo?.startsWith('/')) {
    finalTo = redirectTo;
  } else if (redirectTo) {
    finalTo = `/${redirectTo}`;
  }

  const finalURL = !isMalformedURL(finalTo) ? finalTo : '/';
  Logger.debug('RedirectRoute: redirecting to', decodeURIComponent(finalURL));

  return <Navigate to={decodeURIComponent(finalURL)} {...rest} />;
};

export default RedirectRoute;
